import React, {useState} from 'react';
import {Link} from "gatsby";
import {stripPrefix} from "../../function/functions";

const ItemSubMenuPop = ({item, index, menuNumber, triggerMenuPop}) => {

    const [open, setOpen ] = useState(false);

    const clickSubMenu = (menuNumber) => {
        setOpen(!open)
        // console.log(open, menuNumber);
        // open ? (
        //     document.body.classList.remove('ovh')
        // ) : ( document.body.classList.add('ovh') )
    };

    let fixUrl = stripPrefix(item.path);
    // if ( item?.connectedNode?.node?.removeSlug?.false ) {
    //     fixUrl = stripPrefix(item.path).replace(/^\/catalog\//, '/');
    // } else {
    //     fixUrl = stripPrefix(item.path);
    // }


    return (
        <li className={item.childItems.nodes && item.childItems.nodes.length > 0 ? 'sub' : ''}>

            {item.path === '#' ? (
                <button type="button" aria-labelledby="button-label" onClick={() => clickSubMenu(menuNumber)} className='a'>{item.label}</button>
            ) : (
                // <Link onClick={() =>triggerMenuPop()} to={item.path.replace("product-category/", "")}>{item.label}</Link>
                <Link onClick={() =>triggerMenuPop()} to={fixUrl}>{item.label}</Link>
            )}


            {item.childItems.nodes && item.childItems.nodes.length > 0 ? (
                <>
                    <ul className={open ? `open ul-sub ul-clear anim` : `close ul-sub ul-clear anim`}>
                        <li>
                            <button className='return' onClick={() => clickSubMenu(menuNumber)} type="button" aria-labelledby="button-label">{item.label}</button>
                        </li>
                        {item.childItems.nodes.map((li, index_li) => {
                            // if ( li?.connectedNode?.node?.removeSlug?.false ) {
                            //     fixUrl = stripPrefix(li.path).replace(/^\/catalog\//, '/');
                            // } else {
                            //     fixUrl = stripPrefix(li.path);
                            // }

                            return (
                                <li key={`sub_menu_pop_` + menuNumber + `_` + item.id + `_` + index + `_` + index_li}>
                                    {/*<Link onClick={() =>triggerMenuPop()} className="a" to={li.path.replace("product-category/", "")}>{li.label}</Link>*/}
                                    <Link onClick={() =>triggerMenuPop()} className="a" to={stripPrefix(li.path)}>{li.label}</Link>
                                </li>
                            )
                        })}
                    </ul>
                </>
            ) : null}
        </li>
    )
}
export default ItemSubMenuPop;